<script type="text/javascript">
    this.name = "dancewyse-main";
</script>
<app-nav></app-nav>
<router-outlet></router-outlet>
